import { AxiosInstance } from 'axios';
import {
    VersionsListResponse,
    VersionItemEdit,
    VersionItemAdd,
    GetVersionsQueryParams,
} from 'models/api/versions';
import Id from 'models/id';

const controller = '/versions'
const blockController = '/blocks'

export const getVersions = async (axios: AxiosInstance, body: GetVersionsQueryParams, isActive = true) => {
    const platform = body.platform ? `in:${body.platform},all` : null;

    const params = {...body, isActive, platform }

    const { data: { data: requestData } } = await axios.get<VersionsListResponse>(controller, { params });

    const records = { 
        ...requestData,
        records: requestData.records.filter((item) => item.isActive === isActive)
    };

    return records;
};

export const createVersion = async (axios: AxiosInstance, item: VersionItemAdd) =>
    await axios.post<Id>(controller, item);

export const updateVersion = async (axios: AxiosInstance, item: VersionItemEdit) => {
    await axios.put<null>(controller + `/${item.id}`, item);
};

export const reactivateVersion = async (axios: AxiosInstance, id: string) =>
    await axios.patch<null>(controller + `/${id}/reactivate`);


export const deleteVersion = async (axios: AxiosInstance, id: string) =>
    await axios.delete<null>(controller + `/${id}`);

export const setVersionStatus = async (axios: AxiosInstance, id: string, status: string) =>
    await axios.patch<null>(controller + `/${id}/statuses/${status}`);

export const setVersionBlock = async (axios: AxiosInstance, version_id: string) =>
    await axios.post<null>(blockController, { version_id });

export const hardDeleteVersion = async (axios: AxiosInstance, id: string) =>
    await axios.delete<null>(controller + `/${id}`, {
        headers: {
            'x-operation-harddelete': true,
        }
    });
